import React, { useRef, useState } from 'react';
import './DemoVideos.css';

const DemoVideos = () => {
  const scrollContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Video data - easy to add more videos
  const videos = [
    {
      id: 1,
      anchorId: 'demo-healing',
      src: '/testhealing.mp4',
      title: 'AI Test Healing',
      description: <>Watch AI analyze a test failure and automatically suggest healing adaptations <span className="demo-animated-highlight">without any effort from the user</span></>,
      duration: '2:15'
    },
    {
      id: 2,
      anchorId: 'demo-bugfix',
      src: '/bugfixing.mp4',
      title: 'AI Bug Fixing',
      description: <>See how Qate detects bugs and <span className="demo-animated-highlight">automatically suggests code fixes</span><span style={{ marginLeft: '20px' }}>to resolve them</span></>,
      duration: '1:45'
    },
  ];

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollLeft = container.scrollLeft;
      const cardWidth = container.offsetWidth * 0.85;
      const newIndex = Math.round(scrollLeft / cardWidth);
      setActiveIndex(Math.min(newIndex, videos.length - 1));
    }
  };

  const scrollToIndex = (index) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.offsetWidth * 0.85;
      container.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };

  return (
    <section className="demo-videos-section" id="demo">
      <div className="demo-videos-container">
        <div className="demo-videos-header">
          <h2 className="demo-videos-title">See It In Action</h2>
          <p className="demo-videos-subtitle">
            Watch how Qate is not only in the background, discovering workflows, building tests, <strong>but there to talk to</strong>
          </p>
        </div>

        <div className="demo-videos-wrapper">
          {/* Callout arrows - only show for single video on desktop */}
          <div className="demo-callout demo-callout-left">
            <span className="demo-callout-text">AI not hidden in the background</span>
            <svg className="demo-callout-arrow" viewBox="0 0 60 50" fill="none">
              <path d="M5 10 Q15 15 25 25 Q35 35 45 45" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/>
              <path d="M40 48 L47 47 L48 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          </div>

          <div className="demo-callout demo-callout-right">
            <svg className="demo-callout-arrow" viewBox="0 0 60 50" fill="none">
              <path d="M55 10 Q45 15 35 25 Q25 35 15 45" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/>
              <path d="M20 48 L13 47 L12 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
            <span className="demo-callout-text">Real live app footage</span>
          </div>

          <div
            className="demo-videos-scroll-container"
            ref={scrollContainerRef}
            onScroll={handleScroll}
          >
            {videos.map((video, index) => (
              <div key={video.id} id={video.anchorId} className="demo-video-card">
                <div className="demo-video-wrapper">
                  <video
                    className="demo-video-player"
                    controls
                    preload="none"
                  >
                    <source src={video.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="demo-video-duration">{video.duration}</div>
                </div>
                <div className="demo-video-info">
                  <h3 className="demo-video-title">{video.title}</h3>
                  <p className="demo-video-description">{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Proud of our app callout - positioned below cards */}
        <div className="demo-callout-below" style={{ flexDirection: 'column' }}>
          <svg className="demo-callout-arrow" viewBox="0 0 40 30" fill="none">
            <path d="M20 25 Q20 15 25 8 Q28 4 32 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/>
            <path d="M28 5 L33 1 L35 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
          <span className="demo-callout-text">proud of our app</span>
        </div>

        {/* Dot indicators - only show if more than 1 video */}
        {videos.length > 1 && (
          <div className="demo-videos-dots">
            {videos.map((_, index) => (
              <button
                key={index}
                className={`demo-dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => scrollToIndex(index)}
                aria-label={`Go to video ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default DemoVideos;
